module.exports = __webpack_public_path__ + "img/avatar5.03020856.png";